<div class="container-fluid osp-booking">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row ">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h1 class="page-sub-title cv-text-dark my-3 my-xl-4">
              Book Now
            </h1>
          </div>
          <h5 class="cv-text-dark">SELECT FINANCE OPTIONS</h5>
          <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8 order-2 order-md-1">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 tab-box tab-financePartner">
                <div class="row">
                  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div class="financePartnerWrapper "
                      [ngClass]="productDetailList && productDetailList.sub_lob !== 'SCV Pickups' ? '' : ''">
                      <!--disableds-->
                      <input type="radio" (click)="tabChange($event)" name="financePartner" id="needFinancePartner"
                        value="need-finance" [checked]="tabValue == 'need-finance'" />
                      <label for="needFinancePartner" class="financepartner cursor-pointer">
                        <div class="icon">
                          <img [src]="environment1 + 'images/new-images/home.svg'" alt="home" loading="lazy">
                        </div>
                        <div class="content">
                          <h6>Proceed For Online Finance</h6>
                          <p>Find a finance partner before you book your commercial vehicle</p>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                    *ngIf="typeOfBookingFni !== 'FinanceJourney' && typeOfBookingFni !== 'FinanceJourneyNonOsp'">
                    <div class="financePartnerWrapper  ">
                      <input type="radio" name="financePartner" id="haveFinancePartner" value="have-finance"
                        (click)="tabChange($event)" [checked]="tabValue == 'have-finance'" />
                      <label for="haveFinancePartner" class="financepartner cursor-pointer">
                        <div class="icon">
                          <img [src]="environment1 + 'images/new-images/person.svg'" alt="person" loading="lazy">
                        </div>
                        <div class="content">
                          <h6>Proceed For Online Booking</h6>
                          <p>Just pay the booking amount if you already have a finance partner </p>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>




                <!-- <div class="row tab-financenext">
                  <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 offset-md-4">
                    <div class="row">
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <button type="button" class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg w-100">Save as Draft</button>
                      </div>
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <button type="button"  class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100">Proceed</button>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>


              <!--Need Finance Partner-->
              <app-finance-booking *ngIf="tabValue == 'need-finance'" (dealerData)=ondealerDataChange($event)
                (VCPriceChange)=onVCPriceChange($event) (quantityChange)=onQuantityChange($event)
                [productDetailsData]="productDetailList"></app-finance-booking>

              <!--Have Finance Partner-->
              <app-general-booking *ngIf="tabValue == 'have-finance'" (dealerData)=ondealerDataChange($event)
                (VCPriceChange)=onVCPriceChange($event) (quantityChange)=onQuantityChange($event)></app-general-booking>
              <!--Order Confirmation-->
              <!-- <app-order-confirmation></app-order-confirmation> -->
            </div>
          </div>

          <ng-container *ngIf="!productDetailList || !productLoaded ;else productTemplate">
            <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 product-info order-1 order-md-2">
              <div class="order-summary">
                <ngx-skeleton height="200px" width="300px"></ngx-skeleton>
              </div>
              <div class="product-details">
                <div class="name-status">
                  <ngx-skeleton height="15px"></ngx-skeleton>
                </div>
                <div class="product-price divider">
                  <ngx-skeleton height="15px"></ngx-skeleton>
                </div>
                <div class="product-booking-amount pb-0 divider">
                  <div class="booking-amount">
                    <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
                  </div>
                  <div class="product-quantity">
                    <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
                  </div>
                </div>
                <div class="total-booking-amount">
                  <ngx-skeleton height="15px" width="300px"></ngx-skeleton>
                </div>
                <div class="product-quantity" *ngIf=" isVasAvailable && VasData?.VASBookingAmount">
                  VAS Booking Amount <span>{{VasData?.VASBookingAmount}}</span>
                </div>
                <div class="total-booking-amount">
                  Total Booking Amount <span>₹{{isVasAvailable && VasData ? getFinalAmt(VasData,totalAmount) :
                    totalAmount}}</span>
                </div>
              </div>

            </div>

          </ng-container>

          <ng-template #productTemplate>
            <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 product-info order-1 order-md-2">
              <div class="order-summary">
                <img alt=" {{productDetailList?.model}} " src="{{ productDetailList?.images[0]?.image_url }}"
                  loading="lazy" />
              </div>
              <div class="product-details">
                <div class="name-status">
                  {{ productDetailList?.model }}
                </div>
                <div class="product-price divider" *ngIf="productDetailList.price_range">
                  <p>Ex-showroom Price</p>
                  <div class="product-price-amount">
                    <div class="price"> {{ newVCPrice ? (newVCPrice | currency:'INR':'symbol':'4.0-0') :
                      (productDetailList?.price_range | currency:'INR':'symbol':'4.0-0') }} </div>
                    <!-- <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#fetchOn_price">Fetch On-Road
                      Price</a> -->
                  </div>
                </div>
                <div class="product-price divider" *ngIf="!productDetailList.price_range">
                  <p>Please contact to Dealer.</p>
                </div>
                <div *ngIf="((!isfnijourney) || (payment_data?.length == 0 && isfnijourney))">
                  <div class="product-booking-amount pb-0 divider">
                    <div class="booking-amount">
                      Booking Amount <span>{{ changedbookingAmount ? changedbookingAmount
                        :productDetailList?.down_payment |
                        currency:'INR':'symbol':'4.0-0'
                        }} </span>
                    </div>
                    <div class="product-quantity">
                      Quantity <span>{{quantity}}</span>
                    </div>
                    <div class="product-quantity" *ngIf="isVasAvailable && VasData?.VASBookingAmount">
                      VAS Booking Amount <span>{{VasData?.VASBookingAmount}}</span>
                    </div>
                  </div>

                  <div class="total-booking-amount">
                    Total Booking Amount <span>₹{{isVasAvailable && VasData?.VASBookingAmount ?
                      getFinalAmt(VasData,totalAmount) : totalAmount}}</span>
                  </div>

                </div>
                <div *ngIf="isfnijourney && payment_data?.length > 0">
                  <div class="product-booking-amount pb-0 divider">
                    <div class="booking-amount">
                      Booking Amount
                      <span>{{
                        changedbookingAmount
                        ? changedbookingAmount
                        : (payment_data[0]?.amount
                        | currency : "INR" : "symbol" : "4.0-0")
                        }}
                      </span>
                    </div>
                    <div class="product-quantity">
                      Quantity <span>{{ quantity }}</span>
                    </div>
                    <div class="product-quantity" *ngIf="payment_data?.length > 1">
                      VAS Booking Amount
                      <span>{{ payment_data[1]?.amount }}</span>
                    </div>
                  </div>
                  <div class="total-booking-amount">
                    Total Booking Amount
                    <span>₹{{payment_data[0]?.trans_total_amount/100
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="estimate_date" *ngIf="minDate && maxDate">
                Estimate Date of delivery <span>{{ minDate }} - {{ maxDate }}</span>
              </div>
              <div *ngIf="minDate && maxDate" class="margin-top:10px">*Tentative lead time may vary for large quantity
                orders. Firm dates will be available after internal check by TML</div>
                <div class="offer-box" *ngIf="schemeDetailList?.scheme_master?.scheme_value > 0">
                  <div class="offer-content">
                    <div class="coin-icon">
                      <img [src]="environment1 + 'assets/images/Layer_2.webp'" alt="Layer-image">
                    </div>
                    <div class="offer-text">
                      <h3>Unlock fantastic reward on your online finance and booking.
                        <!-- <span>
                          {{ schemeDetailList?.scheme_master?.scheme_bonus_type == 'Flat'
                              ? schemeDetailList?.scheme_master?.scheme_value
                              : schemeDetailList?.scheme_master?.max_value }}
                        </span>  coins on your {{schemeDetailList?.scheme_master?.parameter}} ! -->
                      </h3>
                      <p *ngIf="schemeDetailList?.scheme_master?.scheme_bonus_type != 'Flat'">Score instant {{schemeDetailList?.scheme_master?.scheme_value}}% of your booking amount as online reward points.</p>
                      <span class="footnote">1 point = 1 INR</span>
                    </div>
                  </div>
                  <div class="offer-action">
                    <a (click)="gotorewardtermscondition(schemeDetailList)" class="view-offers">
                  T&C applied
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 18l6-6-6-6"/>
                      </svg>
                    </a>
                  </div>
                </div>
            </div>

          </ng-template>

        </div>
      </div>
    </div>

  </div>
</div>
